<div style="text-align: center;" *ngIf="isProjectSpinning">
    <nz-spin nzSimple></nz-spin>
</div>

<div nz-row *ngIf="!isProjectSpinning">
    <div nz-col nzSpan="24">
        <div class="formname">{{title}}</div>
    </div>

    <div style="border-radius: 10px; border: solid red 1px;" nz-col class="my-box" nzSpan="6">
        <div style="text-align: center;">
            <nz-tag [nzColor]="'red'">Pending</nz-tag>
        </div>
    </div>

    <div style="border-radius: 10px; border: solid green 1px;" nz-col class="my-box" nzSpan="6">
        <div style="text-align: center;">
            <nz-tag [nzColor]="'green'">Started</nz-tag>
        </div>
    </div>

    <div style="border-radius: 10px; border: solid yellow 1px;" nz-col class="my-box" nzSpan="6">
        <div style="text-align: center;">
            <nz-tag [nzColor]="'yellow'">Completed</nz-tag>
        </div>
    </div>

    <div style="border-radius: 10px; border: solid orange 1px;" nz-col class="my-box" nzSpan="6">
        <div style="text-align: center;">
            <nz-tag [nzColor]="'orange'">On Hold</nz-tag>
        </div>
    </div>
</div>
        